














































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

// Components
import UmiaUserRoles from '@/components/Staff/UserManagement/Roles/UmiaRoles.vue';
import AmicUserRoles from '@/components/Staff/UserManagement/Roles/AmicRoles.vue';
import InsureCareTeamsUsersRoles from '@/components/Staff/UserManagement/Roles/InsureCareTeamsRoles.vue';
import MmicUserRoles from '@/components/Staff/UserManagement/Roles/MmicRoles.vue';
import RrgUserRoles from '@/components/Staff/UserManagement/Roles/RrgRoles.vue';
import Checkbox from '@/components/Form/Checkbox.vue';
import Loading from '@/components/Global/Loading.vue';
import Alert from '@/components/Global/Alert.vue';

// Services
import Staff from '@/services/Staff';
import * as Sentry from '@sentry/browser';

@Component({
	name: 'TabPermissions',
	components: {
		Loading,
		UmiaUserRoles,
		AmicUserRoles,
		InsureCareTeamsUsersRoles,
		MmicUserRoles,
		RrgUserRoles,
		Checkbox,
		Alert,
	},
})
export default class TabPermissions extends Vue {
	@Prop() private user: any;
	@Prop() private siteAccess: any;
	private sites: any;
	private loadingSites: boolean;
	private error: boolean;

	constructor() {
		super();

		this.sites = [];
		this.loadingSites = true;
		this.error = false;
	}

	@Watch('sites', { deep: true })
	private watchSites() {
		this.user.brands = this.sites
			.map(o => {
				if (o.checked === true) {
					return o.site_id;
				}
			})
			.filter(o => {
				if (o !== 'undefined') {
					return o;
				}
			});

		return true;
	}

	/**
	 * Get all the sites
	 */
	private async loadSites() {
		try {
			const getSites = await Staff.getSites();

			if (getSites.data.length > 0) {
				this.sites = getSites.data.map(o => {
					if (this.siteAccess.find(sa => sa === o.site_id)) {
						o.checked = true;
					} else {
						o.checked = false;
					}
					return o;
				});
			}

			if (!this.user.hasOwnProperty('permissions')) {
				this.user.permissions = {};
			}

			if (!this.user.permissions.hasOwnProperty('umia')) {
				this.user.permissions.umia = {};
			}

			if (!this.user.permissions.hasOwnProperty('insurecareteams')) {
				this.user.permissions.insurecareteams = {};
			}

			if (!this.user.permissions.hasOwnProperty('mmic')) {
				this.user.permissions.mmic = {};
			}

			if (!this.user.permissions.hasOwnProperty('amic')) {
				this.user.permissions.amic = {};
			}

			if (!this.user.permissions.hasOwnProperty('rrg')) {
                                this.user.permissions.amic = {};
                        }

		} catch (e) {
			Sentry.captureException(e);
			this.error = true;
		} finally {
			this.loadingSites = false;
		}
	}

	private async mounted() {
		await this.$store.dispatch('Misc/getRoles');
		await this.loadSites();
	}
}
